import React from "react";
import PropTypes from "prop-types";

//icons
import { FiChevronRight } from "react-icons/fi";

//components
import AnchorLink from "../../AnchorLink";

const propTypes = {
  content: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  gridClass: PropTypes.string,
  isReadMore: PropTypes.bool,
};

const InfoSectionRight = ({ content, className, gridClass, isReadMore }) => {
  return (
    <>
      <section className={["info-wrapper-right", className].join(" ")}>
        <div className="container">
          <div className={["info-grid-right", gridClass].join(" ")}>
            <div className="row">
              <div className="col-8">
                <img
                  className="info-grid-right-img"
                  src={content.right.images.items[0].imgSrc}
                  alt={content.right.images.items[0].alt}
                />
              </div>
              <div className="info-grid-right-details-box">
                <h1 className="info-grid-right-details-title">
                  {content.right.title}
                </h1>
                <p className="info-grid-right-details-desc">
                  {content.right.description}
                </p>
                {isReadMore && (
                  <AnchorLink href="/" className="theme-button">
                    Read More <FiChevronRight className="icon" />
                  </AnchorLink>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const defaultProps = {
  className: "",
  gridClass: "",
  isReadMore: false,
};
InfoSectionRight.propTypes = propTypes;
InfoSectionRight.defaultProps = defaultProps;

export default InfoSectionRight;
